/*
 * header.js — NUR Header-Mega-Disclosure + Sticky-Shadow (WP 1.1).
 * Kein Cart-/Overlay-Eigenbau: Cart = window.Homedia.cart, Overlays = window.Homedia.overlay.
 *
 * Mega = Desktop-Dropdown (Disclosure, KEIN modaler Dialog):
 *   - Hover-Intent (öffnen mit kleiner Verzögerung, schließen mit Grace-Delay)
 *   - Klick = Navigation zur Hauptseite; Panel öffnet per Hover (Desktop) / Pfeil-runter (Tastatur)
 *   - Escape schließt + Fokus zurück auf den Trigger
 *   - Klick außerhalb / auf Scrim schließt
 *   - Tastatur: Tab aus dem Panel heraus schließt; reduced-motion respektiert
 * Progressive Enhancement: ohne JS bleibt „Alle Produkte"-Hamburger ein Link (mobil)
 * und der Nav-Button ist fokussierbar; das Panel ist [hidden] bis JS es öffnet.
 */
(function () {
  'use strict';

  var OPEN_DELAY = 90;   // Hover-Intent öffnen
  var CLOSE_DELAY = 180; // Grace beim Verlassen

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initStickyShadow();
    initMega();
  });

  /* ---------------- Sticky-Shadow ---------------- */
  function initStickyShadow() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    var ticking = false;
    function update() {
      ticking = false;
      if (window.scrollY > 4) header.setAttribute('data-stuck', '');
      else header.removeAttribute('data-stuck');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------------- Mega-Disclosure (mehrere Trigger → je 1 Panel) ----------------
   * Jeder [data-mega-trigger] im Nav öffnet AUSSCHLIESSLICH SEIN eigenes Panel
   * (data-mega-trigger="<panel-id>"). Hover-Intent ist PER TRIGGER: nur das
   * überfahrene Item öffnet sein Panel; wandert der Zeiger auf ein anderes Item,
   * wechselt das offene Panel. Verlassen von Nav+Panel schließt (Grace-Delay).
   * Klick navigiert (kein Toggle); Pfeil-runter öffnet; Escape schließt + Fokus zurück;
   * Scrim/Outside-Click schließt. Desktop-Hover nur bei (hover:hover & pointer:fine).
   */
  function initMega() {
    var root = document.querySelector('[data-mega-root]');
    if (!root) return;

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-mega-trigger]'));
    if (!triggers.length) return;

    var scrim = document.querySelector('[data-mega-scrim]');
    var openTimer = null;
    var closeTimer = null;
    var activeId = null; // panel-id des aktuell offenen Panels (oder null)

    function reduced() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    function isPointerFine() {
      return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }
    function clearTimers() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }
    function panelFor(id) { return id ? document.getElementById(id) : null; }
    function triggerFor(id) {
      for (var i = 0; i < triggers.length; i++) {
        if (triggers[i].getAttribute('data-mega-trigger') === id) return triggers[i];
      }
      return null;
    }

    // Öffnet das Panel zu panelId; schließt ein evtl. anderes offenes Panel sofort.
    function open(panelId) {
      clearTimers();
      if (activeId === panelId) return;
      var panel = panelFor(panelId);
      var trigger = triggerFor(panelId);
      if (!panel || !trigger) return;

      // anderes Panel ohne Fokus-Restore und ohne Scrim-Flackern wechseln
      var switching = false;
      if (activeId && activeId !== panelId) {
        switching = true;
        var prevPanel = panelFor(activeId);
        var prevTrigger = triggerFor(activeId);
        if (prevTrigger) prevTrigger.setAttribute('aria-expanded', 'false');
        if (prevPanel) {
          prevPanel.removeAttribute('data-state');
          prevPanel.hidden = true;
        }
      }

      activeId = panelId;
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (scrim) { scrim.hidden = false; scrim.setAttribute('aria-hidden', 'false'); }
      // Beim WECHSEL zwischen bereits offenen Panels: sofort im offenen Zustand zeigen (kein Fade-in
      // von 0 → sonst Flackern, weil das alte Panel schon weg ist und das neue noch unsichtbar).
      // Beim ERSTEN Öffnen (kein Panel offen) bleibt das sanfte Ein-/Ausblenden via rAF erhalten.
      if (reduced() || switching) {
        panel.setAttribute('data-state', 'open');
      } else {
        window.requestAnimationFrame(function () {
          if (activeId === panelId) panel.setAttribute('data-state', 'open');
        });
      }
    }

    function close(restoreFocus) {
      clearTimers();
      if (!activeId) return;
      var panel = panelFor(activeId);
      var trigger = triggerFor(activeId);
      var closingId = activeId;
      activeId = null;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.removeAttribute('data-state');
      if (scrim) { scrim.hidden = true; scrim.setAttribute('aria-hidden', 'true'); }
      var finish = function () { if (activeId !== closingId && panel) panel.hidden = true; };
      if (reduced()) finish();
      else window.setTimeout(finish, 160);
      if (restoreFocus && trigger) { try { trigger.focus(); } catch (e) {} }
    }

    triggers.forEach(function (trigger) {
      var panelId = trigger.getAttribute('data-mega-trigger');
      var panel = panelFor(panelId);
      if (!panel) return;

      /* --- Klick = echte Navigation zur Hauptseite des Punkts (Decision docs/01 §13:
         Klick→Seite, Hover→Dropdown). Kein preventDefault/Toggle — der <a href> navigiert.
         Das Panel öffnet per Hover (Desktop) bzw. Pfeil-runter (Tastatur). --- */

      /* --- Pfeil-runter öffnet + fokussiert ersten Panel-Link --- */
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Down') {
          e.preventDefault();
          open(panelId);
          var first = panel.querySelector('a[href],button:not([disabled])');
          if (first) { try { first.focus(); } catch (err) {} }
        }
      });

      /* --- Per-Trigger Hover-Intent: nur DIESES Item öffnet SEIN Panel --- */
      trigger.addEventListener('mouseenter', function () {
        if (!isPointerFine()) return;
        clearTimers();
        // Wechsel zwischen offenen Panels: sofort umschalten (kein Re-Open-Delay)
        if (activeId && activeId !== panelId) {
          open(panelId);
        } else if (!activeId) {
          openTimer = window.setTimeout(function () { open(panelId); }, OPEN_DELAY);
        }
      });
      // Trigger verlassen, bevor das Panel offen ist → geplantes Öffnen abbrechen
      trigger.addEventListener('mouseleave', function () {
        if (!isPointerFine()) return;
        if (openTimer && activeId !== panelId) { clearTimeout(openTimer); openTimer = null; }
      });

      /* --- Tab aus dem Panel heraus schließt (kein Trap — Disclosure) --- */
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusables = panel.querySelectorAll('a[href],button:not([disabled])');
        if (!focusables.length) return;
        var last = focusables[focusables.length - 1];
        var first = focusables[0];
        if (!e.shiftKey && document.activeElement === last) {
          close(false);
        } else if (e.shiftKey && document.activeElement === first) {
          close(false);
        }
      });
    });

    /* --- Nav+Panel verlassen schließt (Grace) — am Root, deckt Nav-Zeile + alle Panels ab --- */
    root.addEventListener('mouseleave', function () {
      if (!isPointerFine()) return;
      clearTimers();
      closeTimer = window.setTimeout(function () { close(false); }, CLOSE_DELAY);
    });
    root.addEventListener('mouseenter', function () {
      // zurück in den Nav-Bereich → geplantes Schließen abbrechen
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });

    /* --- Escape schließt + Fokus zurück auf den aktiven Trigger --- */
    document.addEventListener('keydown', function (e) {
      if (!activeId) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close(true);
      }
    });

    /* --- Klick außerhalb / Scrim schließt --- */
    if (scrim) {
      scrim.addEventListener('click', function () { close(false); });
    }
    document.addEventListener('click', function (e) {
      if (!activeId) return;
      if (root.contains(e.target)) return;
      close(false);
    });
  }
})();
